<template lang='pug'>
  #app
    router-view(v-if="user !== null")
    .loading(v-else v-loading='loading')
</template>

<script>
  import Cookies from 'js-cookie'
  import { check_cookie, activate_cookie_listener } from './utils/check_cookie'
  import { auth } from './utils/firebase'
  import { load_analytics } from './utils/analytics'
  export default {
    name: 'app',
    data() {
      return {
        user: null,
        loading: true
      };
    },
    created() {
      const user = auth.currentUser
      user ? this.user = user : check_cookie.call(this)
      activate_cookie_listener.call(this)
    },
    methods: {
      logout() {
        this.user = false
        this.$router.replace('/re-route')
        auth.signOut().then(response => {
          console.log('user signed out of firebase', response)
        }).catch(error => {
          console.log('error signing user out of firebase', error)
        })
      }
    },
    mounted() {
      load_analytics()
    }
  }
</script>

<style lang='scss'>
  body {
    background: #f0f0f0;
  }
  .loading {
    width: 100vw;
    height: 100vh;
  }
</style>
